import { useEffect, useState } from "react";

export function usePipState() {
  const [pipWindow, setPipWindow] = useState(null);

  // Detect enter PiP mode
  useEffect(() => {
    const listener = () =>
      setPipWindow(window.documentPictureInPicture?.window || null);

    listener();
    window.documentPictureInPicture?.addEventListener(
      "enter",
      listener,
      false,
    );
    return () =>
      window.documentPictureInPicture?.removeEventListener(
        "enter",
        listener,
        false,
      );
  }, []);

  // Detect leave PiP mode
  useEffect(() => {
    const listener = () => setPipWindow(null);
    pipWindow?.addEventListener("pagehide", listener, false);
    return () => pipWindow?.removeEventListener("pagehide", listener);
  }, [pipWindow]);

  return {
    isInPipMode: !!pipWindow,
  };
}
